<!--
File Name          : choose-level.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container">
    <div class="remaining-container">
        <div class="lessons-card standard-center-card">
            <img *ngIf="!screenservice.isMobile" width="320" height="80" src="/assets/branding/secondary_logo.svg" alt="Datasnap">
            <div class="standard-card-message">Select Your Level:</div>
            <dx-button *ngFor="let level of unit!.levels" [text]="level.title" height="72px" width="280px" style="font-size: 32px; margin: 8px 16px;"  type="default" (onClick)="openLevel(level.id)"></dx-button>
        </div>
    </div>
</div>